/**
 * Flavor registry — maps flavor type names to their factory functions.
 * Each factory receives (widget, flavorObj) and returns a flavor instance.
 */
import { createEcommerceFlavor } from './ecommerce.js';
import { createHotelsFlavor } from './hotels.js';
import { createRestaurantsFlavor } from './restaurants.js';
import { createToursFlavor } from './tours.js';
import { createLearnerFlavor } from './learner.js';

const FLAVORS = {
  ecommerce: createEcommerceFlavor,
  hotels: createHotelsFlavor,
  restaurants: createRestaurantsFlavor,
  tours: createToursFlavor,
  learner: createLearnerFlavor,
};

/** Common client typos / aliases → canonical keys in FLAVORS */
const FLAVOR_ALIASES = {
  resturants: 'restaurants',
};

/**
 * Resolve a widget flavor name to a registered factory.
 * Accepts case-insensitive keys and known aliases (e.g. resturants → restaurants).
 */
export function loadFlavor(name) {
  if (name == null || typeof name !== 'string') {
    return null;
  }
  const key = FLAVOR_ALIASES[name.trim().toLowerCase()] || name.trim().toLowerCase();
  return FLAVORS[key] || null;
}
